import { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react";
import Button, { ButtonGroup } from "../../../components/bootstrap/Button";
import Modal, { ModalBody, ModalHeader } from "../../../components/bootstrap/Modal";
import Card, { CardBody, CardHeader } from "../../../components/bootstrap/Card";
import { useNavigate } from "react-router-dom";
import { useMst } from "../../../models";


const datas = [
    { label: '탁도', type: 'NTU', icon: 'WaterTb', value: 25, unit: 'NTU', max:10 },
    { label: '잔류염소', type: 'CL', icon: 'WrDroplet', value: 50, unit: 'mg/L', max:10  },
    { label: '수소이온', type: 'pH', icon: 'WrDropletHalf', value: 25, unit: 'pH', max:10 },
    { label: '수온', type: 'Temperature_Out', icon: 'WaterTemp', value: 50, unit: '℃', max:1 },
    { label: '전기전도도', type: 'SNR', icon: 'WrMoisture', value: 7, unit: 'μS/cm', max:1/3 },
]

const WrErrorModal = observer(({ isOpen, setIsOpen, devices, status, userId, onDeviceSelect }) => {
    const navigate = useNavigate();
    const { user } = useMst();

    // const [detailViewDevice, setDetailViewDevice] = useState({});

    // const [viewTab, setViewTab] = useState('');

    // const [params, setParams] = useState({});

    // const [deviceChartData, setDeviceChartData] = useState([]);

    // const [startTime, setStartTime] = useState('');
    // const [endTime, setEndTime] = useState('');

    // const [option, setOption] = useState({});

    // const getDevicePacket = useCallback(async (device) => {
    //     if (device.IMEI) {
    //         params.imei = device.IMEI
    //         const { data } = await PacketService.getPacketList2(params)
    //         setDeviceChartData(data.list)
    //     }
    // }, [params])

    // const getDevice = useCallback(async () => {
    //     const { data } = await DeviceService.getDashboardDeviceList()
    //     // console.log('getDevice', data)

    //     setDevices(data)
    //     setFavoriteDevices(data.filter(d => d.favorite))
    //     if(viewTab === '') setTimeout(() => {setViewTab('MAP')}, 100)
    // }, [viewTab])

    // // useEffect(() => {
    // //     getDevice()
    // // }, [getDevice, isUserAddOpen]);

    // useEffect(() => {
    //     console.log('viewTab', viewTab)
    //     console.log('detailViewDevice', detailViewDevice)
        
    //     if (detailViewDevice?.packets) {
    //         setStartTime(detailViewDevice?.packets[0]?.Start_time || '12:05');
    //         setEndTime(detailViewDevice?.packets[0]?.Sleep_time || '12:00');
    //     }

    //     if (detailViewDevice?.option) {
    //         setOption(detailViewDevice?.option || {});
    //     }

    //     if (viewTab === 'DETAIL') {
    //         for (let i = 0; i < datas.length; i++) {
    //             if (deviceChartData.length > 0 && deviceChartData[deviceChartData.length - 1][datas[i].type] !== null) {
    //                 setSelectedIndex(i)
    //                 break;
    //             }
    //         }
    //     } else if (viewTab === 'MAP2') {
    //         getMaps([detailViewDevice])
    //     }    

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [detailViewDevice, viewTab, deviceChartData]);

	useEffect(() => {
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    return (
        <Modal
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            isStaticBackdrop={true}
            isScrollable={true}
            isCentered={true}
            //fullScreen={true}
            fullScreen={'md'}
            size={'md'}>
            <ModalHeader className='border-top d-flex justify-content-between'>
                <div className={'text-dark'} style={{ fontSize: '1.5rem' }}>
                    <b>장비 현황 목록</b>
                </div>
                <div>
                    <ButtonGroup>
                        <Button
                            type='button'
                            color='dark'
                            icon='Close'
                            onClick={() => {
                                setIsOpen(false);
                            }}>
                            {''}
                        </Button>
                    </ButtonGroup>
                </div>
            </ModalHeader>
            <ModalHeader className='border-top d-flex justify-content-between'>
                <h5>장비 상태 : {status}</h5>
                <h5>{devices.length} 개</h5>
            </ModalHeader>
            <ModalBody style={{ height: '50vh', padding: 5, overflowY: 'auto' }}>
                {devices.map((device, index) => (
                    <div key={`device-modal-${index}`} className='d-flex justify-content-between'
                        style={{ border: '1px solid #5d87ff', backgroundColor: '#ecf2ff', color: '#5d87ff', padding: 15,
                            margin: 10, borderRadius: 10, cursor: 'pointer', fontSize: '1.1rem',
                        }}
                        onClick={() => {
                            console.log('device clicked', device);
                            user.setIMEI(device.IMEI);
                            onDeviceSelect(device);
                            //navigate(`/wrUserDataList` + (userId ? `?userId=${userId}` : ''));
                            // setViewTab('DETAIL');
                        }}
                    >
                        <span>{device.install.acceptNumber}</span>
                        <span>({device.IMEI})</span>
                        <span>감지 시각: {device.updatedAt}</span>
                    </div>
                ))}
            </ModalBody>




        </Modal>
    );
});

export default WrErrorModal;